import { Link } from 'react-router-dom';
import './list_article_card.css';

function ListArticleCard({ post, rootClassName = 'feed-card' }) {
    return (
        <Link to={`/blog/${post.slug}`} className={rootClassName}>
            <img src={post.imageUrl} alt={post.title} className={`${rootClassName}-image`} />
            <div className={`${rootClassName}-content`}>
                <h4 className={`${rootClassName}-title`}>{post.title}</h4>
                <span className={`${rootClassName}-date`}>{post.date}</span>
            </div>
        </Link>
    );
};

export default ListArticleCard;
